import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import {
  IconBackdrop,
  IconBackdropSize,
  IconBackdropStyle,
  IconColor,
  IconSize,
} from '@freelancer/ui/icon';
import { FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'fl-widget-button',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetButtonComponent {}

@Component({
  selector: 'fl-widget',
  template: `
    <fl-card [flMarginBottom]="'small'">
      <div
        class="Header"
        [flMarginBottom]="'small'"
      >
        <fl-icon
          [backdrop]="iconBackdrop"
          [backdropStyle]="IconBackdropStyle.TRANSPARENT"
          [backdropSize]="IconBackdropSize.XXXSMALL"
          [color]="iconColor"
          [name]="iconName"
          [size]="IconSize.SMALL"
          [flMarginRight]="'xxsmall'"
        ></fl-icon>
        <p
          class="text-small font-medium"
          i18n="Widget title"
        >
          {{ titleText }}
        </p>
      </div>
      <p [flMarginBottom]="'small'">
        <ng-content></ng-content>
      </p>
      <fl-button
        i18n="Widget Button"
        [display]="'block'"
        [color]="ButtonColor.DEFAULT"
        [size]="ButtonSize.SMALL"
        [busy]="busy"
        (click)="handleButtonClick()"
      >
        {{ buttonText }}
        <ng-content select="fl-widget-button"></ng-content>
      </fl-button>
    </fl-card>
  `,
  styleUrls: ['./widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  FontWeight = FontWeight;
  IconBackdropSize = IconBackdropSize;
  IconBackdropStyle = IconBackdropStyle;
  IconSize = IconSize;
  TextSize = TextSize;

  @Input() iconBackdrop: IconBackdrop;
  @Input() iconColor: IconColor;
  @Input() titleText: string;
  @Input() buttonText: string;
  @Input() height: string;
  @Input() width: string;
  @Input() iconName: string;
  @Input() busy: boolean;
  @Output() buttonClick = new EventEmitter<void>();

  handleButtonClick(): void {
    this.buttonClick.emit();
  }
}
